import cx from 'classnames';
import { AlertOctagon, ChevronRight } from 'ethena-icons';
import _ from 'lodash';
import { ElementType, HTMLAttributes } from 'react';
import css from './Navigation.module.scss';

const Navigation = ({ children, ...rest }: HTMLAttributes<HTMLElement>) => (
  <nav {...rest}>
    <ol>{children}</ol>
  </nav>
);

interface INavigationItemProps {
  icon: ElementType;
  isDisabled?: boolean;
  isInvalid?: boolean;
  label: string;
  onClick: () => void;
  values: string[];
}

const NavigationItem = ({
  icon: Icon,
  isDisabled,
  isInvalid,
  label,
  onClick,
  values,
}: INavigationItemProps) => (
  <li
    className={cx(css.item, {
      [css.disabled]: isDisabled,
      [css.invalid]: isInvalid,
    })}
  >
    <button className={css.button} onClick={onClick}>
      <span className={css.left}>
        <Icon height={18} width={18} />
        {label}
      </span>
      <span className={css.right}>
        {isInvalid && (
          <AlertOctagon
            className={cx('ethena-icon', css.invalidIcon)}
            height={14}
            width={14}
          />
        )}
        <div className={css.valuesContainer}>
          {_.map(values, (value) => (
            <div className={css.valueContainer}>{value}</div>
          ))}
        </div>
        {!isDisabled && (
          <ChevronRight className={css.chevronIcon} height={19} width={19} />
        )}
      </span>
    </button>
  </li>
);

Navigation.Item = NavigationItem;

export { Navigation };
